import { render, staticRenderFns } from "./DetailsRequestCourier.vue?vue&type=template&id=79312682&"
import script from "./DetailsRequestCourier.vue?vue&type=script&lang=js&"
export * from "./DetailsRequestCourier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports